export enum PurchaseTypes {
  PLAN = 'PLAN',
  ITEMS = 'ITEMS',
  ORDER = 'ORDER',
  DISTRIBUTOR = 'DISTRIBUTOR',
}
